import { KioskViewId } from "../types/types";

export interface KioskTabFeatureFlag {
    enabled: boolean;
    adminOnly: boolean;
}

export const KIOSK_TAB_FEATURE_FLAGS: Record<KioskViewId, KioskTabFeatureFlag> = {
    language: { enabled: true, adminOnly: true },
    greeting: { enabled: true, adminOnly: true },
    hint: { enabled: true, adminOnly: true },
    marquee: { enabled: true, adminOnly: true },
    advertisement: { enabled: true, adminOnly: true },
    qrcode: { enabled: true, adminOnly: true },
    festival: { enabled: true, adminOnly: true },
    background: { enabled: true, adminOnly: true },
    photoFilter: { enabled: true, adminOnly: true },
    volume: { enabled: true, adminOnly: true },
    weather: { enabled: true, adminOnly: true },
    interaction: { enabled: true, adminOnly: true },
    timeAlert: { enabled: true, adminOnly: true },
    layout: { enabled: true, adminOnly: true },
    subtitleSpeed: { enabled: true, adminOnly: true },
    bidirectional_translation: { enabled: true, adminOnly: true },
    game: { enabled: true, adminOnly: true },
    characterAvatar: { enabled: false, adminOnly: true },
};
